var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelationshipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F3F3F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.625 38.9668C16.625 39.8367 17.3302 40.5418 18.2 40.5418H24.9667C25.8365 40.5418 26.5417 39.8367 26.5417 38.9668V34.5335C26.5417 33.6636 25.8365 32.9585 24.9667 32.9585H18.2C17.3302 32.9585 16.625 33.6636 16.625 34.5335V38.9668ZM18.375 38.7918V34.7085H24.7917V38.7918H18.375Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0417 21.4668C23.0417 22.3367 23.7468 23.0418 24.6167 23.0418H31.3833C32.2532 23.0418 32.9583 22.3367 32.9583 21.4668V17.0335C32.9583 16.1636 32.2532 15.4585 31.3833 15.4585H24.6167C23.7468 15.4585 23.0417 16.1636 23.0417 17.0335V21.4668ZM24.7917 21.2918V17.2085H31.2083V21.2918H24.7917Z",
    fill: "#656579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4583 38.9668C29.4583 39.8367 30.1635 40.5418 31.0333 40.5418H37.8C38.6698 40.5418 39.375 39.8367 39.375 38.9668V34.5335C39.375 33.6636 38.6698 32.9585 37.8 32.9585H31.0333C30.1635 32.9585 29.4583 33.6636 29.4583 34.5335V38.9668ZM31.2083 38.7918V34.7085H37.625V38.7918H31.2083Z",
    fill: "#656579"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7083 29.7502V33.8335H22.4583V29.7502C22.4583 28.9447 23.1113 28.2918 23.9167 28.2918H32.0833C32.8887 28.2918 33.5417 28.9447 33.5417 29.7502V33.8335H35.2917V29.7502C35.2917 27.9782 33.8552 26.5418 32.0833 26.5418H23.9167C22.1448 26.5418 20.7083 27.9782 20.7083 29.7502Z",
    fill: "#656579"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.125 22.1668V27.4168H28.875V22.1668H27.125Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelationshipIcon);
export default __webpack_public_path__ + "static/media/relationship-icon.d4f25ad86f6ab4845a930b6b17d589d8.svg";
export { ForwardRef as ReactComponent };